import { isRejectedWithValue } from '@reduxjs/toolkit'
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit'
import { resetAuthState } from './authentication/slice'

export const logoutMiddleware: Middleware = (api: MiddlewareAPI) => (next) => (action: any) => {
  const status = action.payload?.status || action.payload?.originalStatus

  if (isRejectedWithValue(action) && status === 401) {
    api.dispatch(resetAuthState())
  }

  return next(action)
}
